import React, { useState } from "react";
import Brands from "../common/Brands/Brands";
import Footer from "../common/Footer/Footer";
import FooterThree from "../common/Footer/FooterThree";
import FullScreenBtn from "../common/FullScreenBtn";
import Menu from "../common/Menu/Menu";
import Team from "../common/Team/Team";
import Testimonial from "../common/Testimonial/Testimonial";
import AboutThree from "./AboutThree";
import BlogThree from "./ProductSlider";
import CategoryThree from "./CategoryThree";
import ContactThree from "./ContactThree";
import PortfolioThree from "./PortfolioThree";
import Promotion from "./Promotion";
import SliderHomeThree from "./SliderHomeThree";
import ElevatorLoader from "../Loder/ElevatorLoader";
import ProductSlider from "./ProductSlider";
import Ourclient from "../common/Testimonial/Ourclient";




const HomeThree = () => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <SliderHomeThree />
      <AboutThree />
      <CategoryThree />
      <FullScreenBtn />
      {/* <PortfolioThree /> */}
      <Promotion />
     
      <Testimonial />
      <Ourclient/>
      {/* <Brands /> */}
      <ContactThree />
      <ProductSlider />
     
      <FooterThree />
    </div>
  );
};

export default HomeThree;
